import React from 'react'
import {IoIosArrowDown} from 'react-icons/io';
import css from './SearchSortBy.module.css';

const SortBySommlyScore = ({selectedScore, setSelectedScore}) => {
  return (
    <div>
      <h3>Sort By Rating</h3>
      <div className={css.seleteWrapper}>
        <select
          className={css.varietalSelect}
          name="varietals_bottled"
          id="varietals_bottled"
          onChange={(e) => {
            setSelectedScore(e.target.value)
          }}
          value={selectedScore}
        >
          <option value="high">High to low</option>
          <option value="low">Low to high</option>
        </select>
        <IoIosArrowDown className={css.selectIcon} />
      </div>
    </div>
  )
}

export default SortBySommlyScore
